import { CountryCode, getExampleNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { maskPhoneNumber } from './maskPhoneNumber';

export const getMaskPlaceholder = (countryCode: CountryCode): string => {
  const exampleNumber = getExampleNumber(countryCode, examples);

  if (exampleNumber) {
    return maskPhoneNumber(
      exampleNumber.formatInternational(),
      exampleNumber?.countryCallingCode?.length
    );
  }
  return '';
};
